import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, HostListener } from '@angular/core';

export interface DropdownOption {
  label: string;
  value: any;
  disabled?: boolean;
}

@Component({
  selector: 'ebo-dropdown',
  templateUrl: './ebo-dropdown.component.html',
  styleUrls: ['./ebo-dropdown.component.scss']
})
export class EboDropdownComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() placeholder = 'Select an option';
  @Input() options: DropdownOption[] = [];
  @Input() disabled = false;
  @Input() required = false;
  @Input() error = '';
  @Input() hint = '';
  @Input() value: any = null;

  @Output() selectionChange = new EventEmitter<any>();

  selectedValue: any = null;
  isOpen = false;
  isFocused = false;
  private blurTimeout: any;

  constructor() {}

  ngOnInit(): void {
    // Initialize with the input value
    if (this.value !== null && this.value !== undefined) {
      this.selectedValue = this.value;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Update selectedValue when value input changes
    if (changes.value) {
      const currentValue = changes.value.currentValue;
      if (currentValue !== undefined && currentValue !== null) {
        this.selectedValue = currentValue;
      }
    }

    // Reset dropdown state when options change and dropdown is open
    if (changes.options && this.isOpen) {
      this.isOpen = false;
    }
  }

  toggleDropdown(): void {
    if (!this.disabled) {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.isFocused = true;
      }
      // Clear any pending blur timeout when toggling
      if (this.blurTimeout) {
        clearTimeout(this.blurTimeout);
        this.blurTimeout = null;
      }
    }
  }

  selectOption(option: DropdownOption): void {
    if (!option.disabled && !this.disabled) {
      this.selectedValue = option.value;
      this.isOpen = false;
      this.isFocused = false;

      // Clear any pending blur timeout
      if (this.blurTimeout) {
        clearTimeout(this.blurTimeout);
        this.blurTimeout = null;
      }

      // Emit the selection change event
      this.selectionChange.emit(option.value);
    }
  }

  getSelectedLabel(): string {
    if (this.selectedValue === null || this.selectedValue === undefined) {
      return this.placeholder;
    }

    const selected = this.options.find(opt => opt.value === this.selectedValue);
    return selected ? selected.label : this.placeholder;
  }

  onBlur(): void {
    this.isFocused = false;
    // Use a timeout to allow click events on options to complete first
    this.blurTimeout = setTimeout(() => {
      if (!this.disabled) {
        this.isOpen = false;
      }
      this.blurTimeout = null;
    }, 150);
  }

  @HostListener('keydown.escape')
  onEscapeKey(): void {
    this.isOpen = false;
    this.isFocused = false;
  }

  /** trackBy for options *ngFor – prevents DOM destruction when options array reference changes */
  trackByValue(_index: number, option: DropdownOption): any {
    return option.value;
  }
}
